<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>
@if (!showSpinner) {
<div class="flex flex-row overall-summary mt-24">
  <div class="flex flex-row items-center ml-24 p-24 onboarded">
    <div class="fs-14 fw-600 mr-10">{{'TENANT_LIST.ONBOARDED' | transloco}}</div>
    <div class="flex justify-center items-center fs-20 fw-600 mr-30 onboarded-count">{{onboardedTenant}}</div>
    <div class="flex items-center summary-btn azure mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_LIST.AZURE' | transloco}}:</span>
      <span class="fs-20 fw-600">{{azureCount}}</span>
    </div>
    <div class="flex items-center summary-btn aws mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_LIST.AWS' | transloco}}:</span>
      <span class="fs-20 fw-600">{{awsCount}}</span>
    </div>
    <div class="flex items-center summary-btn foundation mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_FORM.FOUNDATION' | transloco}}:</span>
      <span class="fs-20 fw-600">{{foundationCount}}</span>
    </div>
    <div class="flex items-center summary-btn non-foundation mr-12">
      <span class="fs-14 fw-400 mr-4 non-foundation-count">{{'TENANT_FORM.2.0_COUNT' | transloco}}:</span>
      <span class="fs-20 fw-600 non-foundation-count">{{nonFoundationCount}}</span>
    </div>
  </div>
  <div class="flex flex-row items-center ml-24 p-24 environments">
    @if (envDataLoaded) {
    <div class="fs-14 fw-600 mr-10 primary-color">{{'TENANT_LIST.ENVIRONMENTS' | transloco}}</div>
    <div class="flex justify-center items-center fs-20 fw-600 mr-30 onboarded-count">{{instancesCount}}</div>
    <div class="flex items-center summary-btn nonpii mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_LIST.NONPII' | transloco}}:</span>
      <span class="fs-20 fw-600">{{dataZoneCount?.nonpii}}</span>
    </div>
    <div class="flex items-center summary-btn pii mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_LIST.PII' | transloco}}:</span>
      <span class="fs-20 fw-600">{{dataZoneCount?.pii}}</span>
    </div>
    <div class="flex items-center summary-btn prod mr-12">
      <span class="fs-14 fw-400 mr-4">{{'TENANT_LIST.PROD' | transloco}}:</span>
      <span class="fs-20 fw-600">{{dataZoneCount?.prod}}</span>
    </div>
    <div class="ml-12 fs-14 fw-400 last-quarter">+{{lastThreeMonthsCount}} {{'TENANT_LIST.LAST_QUARTER' | transloco}}</div>
    } @else {
    <div class="flex flex-row">
      <div class="skeleton-loader-header w-150">
        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-loader-header">
        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-loader-header">
        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-loader-header">
        <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
      </div>
    </div>
    }
  </div>
</div>
} @else {
  <div class="skeleton-loader">
    <ngx-skeleton-loader count="2" appearance="line"></ngx-skeleton-loader>
  </div>
}
<div class="flex flex-row justify-end pl-24 pr-24 pb-8 pt-24">
  <div class="flex flex-row">
    <div>
      <button class="flex justify-center items-center white-btn" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
      </button>
    </div>
  </div>
</div>
<div class="flex flex-row flex-wrap justify-start items-center pt-10 pl-24 pr-24 pb-16">
  <ng-container *ngIf="managementType">
    <div class="flex flex-row items-center">
      <span class="fw-400">{{ 'TOOLBAR.TYPE' | transloco }} </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{managementType === ManagementTypes.EXTERNAL? ('TENANT_FORM.2.0_COUNT' | transloco) : ('INSTANCE_LIST.EXTERNAL_FOR_ACTION' | transloco)}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(managementType)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="region">
    <div class="flex flex-row items-center">
      <span class="fw-400">{{ 'TOOLBAR.REGION' | transloco }} </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{region}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(region)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="cloud">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.CLOUD' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{cloud | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(cloud)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="status">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{status | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(status)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <div class="flex flex-row items-center mr-16">
    <span *ngIf="managementType || region || cloud || status" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
</div>

<div class="top-panel p-16 mt--16 ml-10">
  <div class="border-radius">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
    <ng-container matColumnDef="tenantId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.TENANTID' | transloco }}</th>
      <td mat-cell *matCellDef="let data" class="cursor-pointer flex flex-row pt-10 tenant" (click)="openTenanteDetails(data.tenantId)">
        <span class="tenant-id pt-2">{{data.tenantId}}</span> 
        @if (data?.origin === 'external') {
          <span class="version-tag ml-16">{{'TENANT_FORM.2.0_COUNT' | transloco}}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.TEMENOSREGION' | transloco }} </th>
      <td mat-cell *matCellDef="let data"> {{(data.regionPair || data.temenosRegion)}} </td>
    </ng-container>

    <ng-container matColumnDef="target">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.TARGETCLOUD' | transloco }} </th>
      <td mat-cell *matCellDef="let data"> {{(data.cloudProvider || data.targetCloud)}} </td>
    </ng-container>

    <ng-container matColumnDef="creationFlow">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.CREATION_FLOW' | transloco }} </th>
      <td mat-cell *matCellDef="let data">
        <a class="cursor-pointer" (click)="openWorkflowDiagram(data)">{{ 'TENANT_LIST.VIEW_CREATION_FLOW' | transloco }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.STATUS' | transloco }} </th>
      <td mat-cell *matCellDef="let data">       
      @if (data?.status === TenantStatus.IMPLEMENTATION) {
      <div class="flex flex-row">
        <button class="flex flex-row items-center status-button implementation fs-16 fw-500">
          <mat-spinner diameter="14" mode="indeterminate" class="mr-4">
          </mat-spinner>        
          <span>{{data.status}}</span>
        </button>        
      </div>
      } @else if (data?.status === TenantStatus.LIVE) {
      <button class="flex flex-row items-center  status-button live fs-16 fw-500">
        <div class="green-oval mr-4">
          <mat-icon svgIcon="done"></mat-icon>
        </div>
        <span>{{data.status}}</span>
      </button>
      } @else if (data?.status === TenantStatus.OBSOLETE) {
      <button class="flex flex-row items-center status-button obsolete fs-16 fw-500">
        <div class="grey-oval mr-4">
          <mat-icon svgIcon="no_accounts"></mat-icon>
        </div>
        <span>{{data.status}}</span>
      </button>
      }
    </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
  <div *ngIf="data?.length === 0 && !showSpinner && !isFailed" class="flex justify-center p-10 pt-30 pb-30">
    {{'TENANT_LIST.NO_TENANT_MESSAGE' | transloco }}
  </div>
  <div *ngIf="isFailed" class="flex items-center justify-center pt-48 pb-48">
    {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
  </div>
  <div class="pl-24 pr-24">
    <app-paginator class="p-24" [length]="data?.length" [pageSizeOptions]="[10, 15, 20]"
    [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
  </div>
</div>
